module.exports = __webpack_public_path__ + "img/p30.64678a01.png";